import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import LockTwoTone from '@mui/icons-material/LockTwoTone';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useRef, useState } from 'react';
import {
  UpdateUserModal,
  UpdateUserPassword
} from 'src/content/admin/user/UserForm';
import { useAppDispatch, useAppSelector } from 'src/redux/root';
import { logoutAsync } from 'src/utils/api/auth.api';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const user = useAppSelector((s) => s.auth.userInfos);
  const dispatch = useAppDispatch();
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const fullname = `${user.firstName} ${user.lastName}`;
  return (
    <>
      {showUpdate && (
        <UpdateUserModal
          item={user}
          admin
          onHide={() => setShowUpdate(false)}
          show={showUpdate}
        />
      )}
      {showUpdatePassword && (
        <UpdateUserPassword
          admin
          onHide={() => setShowUpdatePassword(false)}
          show={showUpdatePassword}
        />
      )}
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={fullname} src={user.avatar} />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{fullname}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.email}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={fullname} src={user.avatar} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{fullname}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.email}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem
            button
            onClick={() => {
              setOpen(false);
              setShowUpdate(true);
            }}
          >
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary={'Profil'} />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              setOpen(false);
              setShowUpdatePassword(true);
            }}
          >
            <LockTwoTone fontSize="small" />
            <ListItemText primary={'Mot de passe'} />
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button
            onClick={() => {
              logoutAsync(() => null);
            }}
            color="primary"
            fullWidth
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Déconnexion
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
